module.exports = __webpack_public_path__ + "img/forget_back.b3445f84.png";